import { useRoutes } from 'react-router-dom';
import { ParametreView } from '../components/';

export default function ParametreRouter() {
    return useRoutes([
        { path: '', element: <ParametreView/> }
    ]);
}
